import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { clientsData3, clientsDataUpdate3, clientsDataInsert3, clientsDataDelete3 } from './WagonClientsActions'
import { ErrorResponse } from "src/types/error-response.type";
import { SuccessResponse } from "src/types/success-response.type";

type ClientsState = {
  dataClients3: {
    payload: ClientsResponse[] | null,
    payload_update: ClientsResponse | null,
    loading: boolean,
    success: boolean,
    error: string | null;
  }
}

const initialState: ClientsState = {
  dataClients3: {
    loading: false,
    success: false,
    payload_update: null,
    payload: [],
    error: "",
  }
}


export type ClientsResponse = {
  id: number,
  title: string
}


const clientsSlice = createSlice({
  name: 'clients',
  initialState: initialState,
  reducers: {

    // Обычные редьюсеры
    setClientsState(state, action: PayloadAction<ClientsResponse[]>) {
      state.dataClients3.payload = [];
      state.dataClients3.payload = action.payload;
    },

    setClientUpdateState(state, action: PayloadAction<ClientsResponse>) {
      state.dataClients3.payload_update = null;
      state.dataClients3.payload_update = action.payload;
    //  console.log(state.dataClients3.payload_update)

    }

  },


  extraReducers: (builder) => {
    builder
      .addCase(clientsData3.pending, (state) => {
        state.dataClients3.loading = true;
        state.dataClients3.error = null;
      })
      .addCase(clientsData3.fulfilled, (state, action) => {
        state.dataClients3.loading = false;
        clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsData3.rejected, (state, action) => {
        state.dataClients3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients3.error = errorText ? errorText : "";
      })




      ////
      .addCase(clientsDataUpdate3.pending, (state) => {
        state.dataClients3.loading = true;
        state.dataClients3.error = "";
      })
      .addCase(clientsDataUpdate3.fulfilled, (state, action) => {
        state.dataClients3.loading = false;
        clientsSlice.caseReducers.setClientUpdateState(state, action);
      })
      .addCase(clientsDataUpdate3.rejected, (state, action) => {
        state.dataClients3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients3.error = errorText ? errorText : "";
      })



      ////
      .addCase(clientsDataDelete3.pending, (state) => {
        state.dataClients3.loading = true;
        state.dataClients3.error = "";
      })
      .addCase(clientsDataDelete3.fulfilled, (state, action) => {
        state.dataClients3.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsDataDelete3.rejected, (state, action) => {
        state.dataClients3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients3.error = errorText ? errorText : "";
      })




      ////
      .addCase(clientsDataInsert3.pending, (state) => {
        state.dataClients3.loading = true;
        state.dataClients3.error = "";
      })
      .addCase(clientsDataInsert3.fulfilled, (state, action) => {
        state.dataClients3.loading = false;
        //clientsSlice.caseReducers.setClientsState(state, action);
      })
      .addCase(clientsDataInsert3.rejected, (state, action) => {
        state.dataClients3.loading = false;
        const errorText = getErrorText(action.payload as ErrorResponse);
        state.dataClients3.error = errorText ? errorText : "";
      })

  }

})


const getErrorText = (error: ErrorResponse) => {

  //console.log(error);

  switch (error?.error) {
    case "invalid0":
      return "invalid0";
    case "invalid1":
      return "invalid1";
    default:
      return "";
  }
}


export default clientsSlice.reducer